import AccountCircle from '@mui/icons-material/AccountCircle';
import { Badge, IconButton, Typography } from '@mui/material';
import type React from 'react';
import { useUserPhoneNumberVerification } from '../hooks/useUserPhoneNumberVerification';
import { badgeStyle } from '../styles/styles';

interface ProfileIconComponentProps {
  profileMenuId: string;
  onProfileMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  showUserName?: boolean;
  userName?: string;
}

const ProfileIconComponent: React.FC<ProfileIconComponentProps> = ({
  profileMenuId,
  onProfileMenuOpen,
  className,
  showUserName = false,
  userName,
}) => {
  const { isPhoneNumberVerified } = useUserPhoneNumberVerification();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onProfileMenuOpen(event);
  };

  return (
    <IconButton
      edge={showUserName ? 'end' : undefined}
      aria-label="account of current user"
      aria-controls={profileMenuId}
      aria-haspopup="true"
      onClick={handleClick}
      color="inherit"
    >
      <Badge
        badgeContent={!isPhoneNumberVerified ? '!' : undefined}
        color="warning"
        sx={badgeStyle}
        overlap="circular"
      >
        <AccountCircle className={className} />
      </Badge>
      {showUserName && userName && (
        <div style={{ fontSize: '15px', marginLeft: '10px' }}>{userName}</div>
      )}
      {!showUserName && (
        <Typography
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          Profile
        </Typography>
      )}
    </IconButton>
  );
};

export default ProfileIconComponent;

